import { PRODUCT_COLLECTION_PRICING_GET_SUCCESS } from '../actionTypes/ProductCollectionPricingActionTypes';

function ProductCollectionPricingReducer(state = [], action) {
    switch (action.type) {
        case PRODUCT_COLLECTION_PRICING_GET_SUCCESS:
            return action.productCollection;
        default:
            return state;
    }
}

export default ProductCollectionPricingReducer;
